export function createClientId(prefix = "client"): string {
  const randomUUID = globalThis.crypto?.randomUUID?.bind(globalThis.crypto);

  if (randomUUID) return `${prefix}-${randomUUID()}`;

  const randomPart = Math.random().toString(36).slice(2, 10);
  const timePart = Date.now().toString(36);

  return `${prefix}-${timePart}-${randomPart}`;
}
